






















class ResetRequest {
    currentPassword: string;
    userId: number;
    newPassword: string;
}
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
import Enums from '@/lib/enums'
@Component
export default class EditUser extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    user: User = new User();
    reset: ResetRequest = new ResetRequest();

    created() {
     
    }
    haspression() {

    }

    save() {
        (this.$refs.changeForm as any).validate(async (valid: boolean) => {
            this.reset.userId = this.$store.state.user.id
            if (valid) {
                    await this.$store.dispatch({
                        type: 'user/changePassword',
                        data: this.reset
                    });
                    (this.$refs.changeForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
            }
        })
    }
    cancel() {
        (this.$refs.changeForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
        }
    }
    changeRule = {
        newPassword: [{ required: true, message: "当前密码不能为空", trigger: 'blur' }],
        currentPassword: [{ required: true, message: "重置密码不能为空", trigger: 'blur' }],
    }

}
